// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ebu-car-summary-image {
  max-width: 60px;
  max-height: 40px;
  object-fit: contain;
}

.ebu-car-subtitle {
  font-size: 0.75rem;
  color: var(--bs-secondary-color, #6c757d);
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layout/package-summary/package-summary.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yCAAA;EACA,yBAAA;AACF","sourcesContent":[".ebu-car-summary-image {\r\n  max-width: 60px;\r\n  max-height: 40px;\r\n  object-fit: contain;\r\n}\r\n\r\n.ebu-car-subtitle {\r\n  font-size: 0.75rem;\r\n  color: var(--bs-secondary-color, #6c757d);\r\n  text-transform: uppercase;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
